import { render, staticRenderFns } from "./ProgrammaticAppsTable.vue?vue&type=template&id=0f9b8a30&"
import script from "./ProgrammaticAppsTable.vue?vue&type=script&lang=js&"
export * from "./ProgrammaticAppsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports